export const AFTER_LAST_SLASH = /([^/]+$)/g
